// Checks every grant the session receives (sign-in, restore, silent renewal)
// for the scopes k. needs, and turns the reader's Sign in into the app's
// normal redirect. The redirect only ever follows a click: a grant that still
// lacks the scopes afterwards keeps the notice up rather than looping.
//
// The stored user is left in place. The sign-in callback replaces it with the
// new grant, and a reader who abandons the sign-in page keeps a working session.

import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useAuth } from 'react-oidc-context';

import { reportGrant, SIGN_IN_AGAIN_EVENT } from '@/lib/auth/libraryAccess';

export function LibraryAccessWatch() {
  const { user, signinRedirect } = useAuth();
  const location = useLocation();

  useEffect(() => reportGrant(user), [user]);

  useEffect(() => {
    const onSignIn = () => {
      void signinRedirect({ state: { returnTo: location.pathname + location.search + location.hash } }).catch(() => undefined);
    };
    window.addEventListener(SIGN_IN_AGAIN_EVENT, onSignIn);
    return () => window.removeEventListener(SIGN_IN_AGAIN_EVENT, onSignIn);
  }, [signinRedirect, location.pathname, location.search, location.hash]);

  return null;
}
